/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/6/22 8:58
 */
import OnLineServices from './OnLineService'

export { fetchAccountManager } from './CustomerManageModal'

export default OnLineServices

